import React, { useState, useEffect } from 'react';
import Home from './sections/Home';
import Search from './sections/Search';
import getDataFromOrigin from './helpers/getDataFromOrigin';
import { setLocalStorage, getLocalStorage } from './helpers/localStorage';

const App = () => {
	const [isLoading, setLoading] = useState(true);
	const [currentCity, setCurrentCity] = useState(getLocalStorage('currentCity', 'undefined'));
	const [originName, setOriginName] = useState(getLocalStorage('origin', 'openweather'));
	const [currentSection, setCurrentSection] = useState(currentCity === undefined ? 'search' : 'home');
	const [data, setData] = useState('');

	useEffect(() => {
		if (currentCity) {
			getDataFromOrigin(originName, currentCity, setData, setLoading);
		} else {
			setLoading(false)
		}
	},[originName, currentCity])

	const dataOriginChange = (newOriginName) => {
		setData('');
		setLoading(true);
		setOriginName(newOriginName);
		setLocalStorage('origin', newOriginName)
	}

	const sectionChangeHandler = (section) => {
		setCurrentSection(section);
	}

	return (
		<>
			{currentSection === 'home' && 
				<Home data={data} sectionChangeHandler={sectionChangeHandler} city={currentCity.name} dataOriginName={originName} dataOriginChange={dataOriginChange} isLoading={isLoading} />
			}
			{currentSection === 'search' && 
				<Search sectionChangeHandler={sectionChangeHandler} currentCity={currentCity} setCurrentCity={setCurrentCity} />
			}
		</>
	);
}

export default App;
